export enum CONTRACT_TYPE {
	None = 0,
	Initial = 1,
	Prolongation = 2,
	Modification = 3,
}
